import React, { useState, useCallback, useEffect } from "react";

/** Components */
import { TableContainer, TableHead, TableRow, TableCell, TableBody, Table, Paper, ButtonGroup, Button, Collapse, Tooltip } from "@mui/material";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import { FilterBy } from "../../commons/filter.component";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";

/** Api & Function */
import { getInventory, getRptReceipt } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";
import { fitToColumn, sumOfField } from "../../../services/libService";

/** Package */
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
import { ExcelIcon } from "../../commons/miscellaneous";
import * as XLSX from "xlsx";
import { useDispatch } from "react-redux";

const initialFilter = {
  start_date: "",
  end_date: "",
  from_inventory: null,
  to_inventory: null,
  status: null,
};

const RptTicket = () => {
  // custom hook
  const [t] = useTranslation();
  const dispatch = useDispatch();

  // state
  const [isAllow, setAllow] = useState(true);
  const [arrayData, setArrayData] = useState([]);
  const [open, setOpen] = useState(true);
  const [filter, setFilter] = useState({ ...initialFilter });
  // methods
  const handleSearch = useCallback(
    async (source) => {
      setArrayData();
      const params = {};
      if (filter.start_date) params.start_date = filter.start_date;
      if (filter.end_date) params.end_date = filter.end_date;
      if (filter.from_inventory) params.from_inventory_id = filter.from_inventory.id;
      if (filter.to_inventory) params.to_inventory_id = filter.to_inventory.id;
      return getRptReceipt({
        params,
        cancelToken: source?.token,
      }).then((res) => {
        if (res.code === 403) {
          setAllow(false);
          setArrayData([]);
          return;
        }
        if (res.code !== 200) return;
        let newArray = [];
        Object.keys(res.data).forEach((key, index) => {
          let smallGroup = res.data[key].map((item, sub_index) => ({ ...item, index: `${index + 1}.${sub_index + 1}` }));
          newArray.push({
            color: "#FFF6EA",
            index: index + 1,
            billdate: key,
            lit: sumOfField(res.data[key], "lit"),
            l15: sumOfField(res.data[key], "l15"),
            kg: sumOfField(res.data[key], "kg"),
            imp_lit: sumOfField(res.data[key], "imp_lit"),
            imp_l15: sumOfField(res.data[key], "imp_l15"),
            imp_kg: sumOfField(res.data[key], "imp_kg"),
          });
          newArray.push(...smallGroup);
        });
        setArrayData(
          newArray.map((row) => ({
            ...row,
            billdate: row.billdate ? moment(row.billdate).format("DD/MM/YYYY") : "",
            revdate: row.revdate ? moment(row.revdate).format("DD/MM/YYYY") : "",
            impLitGap: row.imp_lit - row.lit < 0 ? `(${Math.round(row.lit - row.imp_lit).toLocaleString()})` : Math.round(row.imp_lit - row.lit).toLocaleString(),
            impL15Gap: row.imp_l15 - row.l15 < 0 ? `(${Math.round(row.l15 - row.imp_l15).toLocaleString()})` : Math.round(row.imp_l15 - row.l15).toLocaleString(),
            impKgGap: row.imp_kg - row.kg < 0 ? `(${Math.round(row.kg - row.imp_kg).toLocaleString()})` : Math.round(row.imp_kg - row.kg).toLocaleString(),
          }))
        );
      });
    },
    [filter]
  );
  const exportExcel = () => {
    const arrData = arrayData.map((item) => ({
      // làm thế này để xác định những cột nào định dạng string trong file csv
      STT: `${item.index}`,
      "Số phiếu xuất": item.code,
      "Số VĐ": item.ext_inv_serial,
      "Ngày xuất": item.billdate,
      "Ngày nhận": item.revdate,
      "LTT - Xuất": +item.lit,
      "L15 - Xuất": +item.l15,
      "KG - Xuất": +item.kg,
      "LTT - Nhập": +item.imp_lit,
      "L15 - Nhập": +item.imp_l15,
      "KG - Nhập": +item.imp_kg,
      "LTT - Hao hụt": item.imp_lit - item.lit,
      "L15 - Hao hụt": item.imp_l15 - item.l15,
      "KG - Hao hụt": item.imp_kg - item.kg,
      "Đơn vị vận tải": item.provider_name,
      "Số xe": item.license_plate,
      "Kho xuất": item.from_inventory,
      "Kho nhập": item.to_inventory,
    }));
    const worksheet = XLSX.utils.json_to_sheet(arrData);
    worksheet["!cols"] = fitToColumn(arrData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet);
    XLSX.writeFileXLSX(workbook, "bkxndc.xlsx");
  };

  useEffect(() => {
    dispatch(setHeaderTitle("BẢNG KÊ XUẤT NHẬP - DI CHUYỂN NỘI BỘ"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button onClick={exportExcel} style={{ display: Boolean(arrayData?.length) ? "" : "none" }}>
            <Tooltip title="Xuất dữ liệu file Excel">
              <ExcelIcon />
            </Tooltip>
          </Button>
          <Button onClick={() => setOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      {/* filter */}
      <Collapse in={open}>
        <CustomDatePicker label={t("Ngày bắt đầu")} value={filter.start_date} onChange={(value) => setFilter((prev) => ({ ...prev, start_date: value }))} sx={{ margin: "5px" }} />
        <CustomDatePicker label={t("Ngày kết thúc")} value={filter.end_date} onChange={(value) => setFilter((prev) => ({ ...prev, end_date: value }))} sx={{ margin: "5px" }} />
        <FilterBy
          getDataFunc={() => getInventory()}
          value={filter.from_inventory}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, from_inventory: newValue }))}
          label={t("Kho xuất")}
          style={{ margin: "5px", width: 210, display: "inline-flex" }}
        />
        <FilterBy
          getDataFunc={() => getInventory()}
          value={filter.to_inventory}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, to_inventory: newValue }))}
          label={t("Kho nhập")}
          style={{ margin: "5px", width: 210, display: "inline-flex" }}
        />

        <ButtonWithAPICall api={handleSearch} disableSnackbar={() => true} variant="outlined">
          {t("Tìm kiếm")}
        </ButtonWithAPICall>
      </Collapse>
      <div>
        {!arrayData ? (
          <LoadingProgress />
        ) : (
          <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                    STT
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                    {t("Số phiếu xuất")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                    {t("Số VĐ")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                    {t("Ngày xuất")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                    {t("Ngày nhận")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }} colSpan={3}>
                    {t("Số lượng xuất")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }} colSpan={3}>
                    {t("Số lượng thực nhập")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }} colSpan={3}>
                    {t("Hao hụt")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                    {t("Đơn vị vận tải")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                    {t("Số xe")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                    {t("Kho xuất")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                    {t("Kho nhập")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ border: "1px solid lightgray" }}>LTT</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>L15</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>KG</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>LTT</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>L15</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>KG</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>LTT</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>L15</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>KG</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {arrayData?.length ? (
                  arrayData.map((row) => (
                    <TableRow style={{ backgroundColor: row.color }} key={row.index}>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.index}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.code}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.ext_inv_serial}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.billdate}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.revdate}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.lit?.toLocaleString()}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.l15?.toLocaleString()}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.kg?.toLocaleString()}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.imp_lit?.toLocaleString()}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.imp_l15?.toLocaleString()}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.imp_kg?.toLocaleString()}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>
                        {row.imp_lit - row.lit < 0 ? `(${Math.round(row.lit - row.imp_lit).toLocaleString()})` : Math.round(row.imp_lit - row.lit).toLocaleString()}
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>
                        {row.imp_l15 - row.l15 < 0 ? `(${Math.round(row.l15 - row.imp_l15).toLocaleString()})` : Math.round(row.imp_l15 - row.l15).toLocaleString()}
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>
                        {row.imp_kg - row.kg < 0 ? `(${Math.round(row.kg - row.imp_kg).toLocaleString()})` : Math.round(row.imp_kg - row.kg).toLocaleString()}
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.provider_name}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.license_plate}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.from_inventory}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{row.to_inventory}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={20}>
                      {t(isAllow ? "Không có dữ liệu" : "No permission")}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default RptTicket;
